/* eslint-disable max-len */
import MERCHANT_USER_STATUS from '@/app/modules/users/merchant/enums/MerchantUserStatus';
import merchantUserFields from '@/app/modules/users/merchant/fields/merchantUserFields';
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { Badge } from '@/common-utils/components/ui/badge';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import DropdownMerchantUserActionsRow from '../../dropdown/DropdownMerchantUserActionsRow';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';

export const columnsMerchantUsersId = 'merchantUsers';

export const columnsMerchantUsers = (headerPackage) => {

    return ([
        generateColumnDefByField({
            field: merchantUserFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row, table }) => (row &&
                <DropdownMerchantUserActionsRow
                    merchantUser={row.original}
                    setLaunchRefetch={headerPackage.setLaunchRefetch}
                    merchantUsersNumber={table.options.data.length}
                />
            )
        }),
        generateColumnDefByField({
            field: merchantUserFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = MERCHANT_USER_STATUS[cell.getValue()];
                return (
                    status &&
                    <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: merchantUserFields.EMAIL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: merchantUserFields.MERCHANT_PROFILE,
            headerPackage: headerPackage,
            customCellFn: ({ cell, row }) => {
                const profileName = cell.getValue(merchantUserFields.MERCHANT_PROFILE.key);
                const isAdmin = getObjectAttributeFromStringKey(row.original,
                    merchantUserFields.IS_ADMIN.key);
                const mainSuffix = isAdmin ? '_main' : '';
                return profileName ?
                    <Entity
                        nowrap
                        entity={`${merchantUserFields.MERCHANT_PROFILE.prefix}${profileName}${mainSuffix}`}
                        namespace={merchantUserFields.MERCHANT_PROFILE.namespace}
                    />
                    : '-';
            }
        }),
        generateColumnDefByField({
            field: merchantUserFields.LAST_LOGIN_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(merchantUserFields.LAST_LOGIN_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: merchantUserFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(merchantUserFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: merchantUserFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(merchantUserFields.UPDATED_AT.key)} />
            )
        })
    ]);
};